<template>
  <div class="form-group">
    <label>{{config.name}} <span v-if="config.required">*</span></label>
    <StarRating v-on:change="onRantingChange"></StarRating>
    <div class="invalid-feedback" :class="{'d-block' : errors.length > 0}"  v-if="errors.length > 0" v-cloak>
      {{ errors[0] }}
    </div>
  </div>
</template>

<script setup>
import StarRating from '@/components/frontend/review/StarRating.vue'
const props = defineProps({
  config: Object,
  errors: Array,
})
const emit = defineEmits(['change'])
const onRantingChange = (e) => {
  emit('change', e);
}
</script>